import { render, staticRenderFns } from "./pushchanneltable.vue?vue&type=template&id=b4df78f6&scoped=true&"
import script from "./pushchanneltable.vue?vue&type=script&lang=js&"
export * from "./pushchanneltable.vue?vue&type=script&lang=js&"
import style0 from "./pushchanneltable.vue?vue&type=style&index=0&id=b4df78f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4df78f6",
  null
  
)

export default component.exports